module.exports = __webpack_public_path__ + "static/media/i3.50d3f9fb.png";